import { createContext } from 'react';

export const NewGradPaidContext = createContext<{
  canNavigate: boolean;
  setCanNavigate: (arg0: boolean) => void;
}>({
  canNavigate: false,
  setCanNavigate: () => {},
});
